import { useCallback } from "react";
import { trpc } from "../../../lib/api/trpc";
import { CreateUserInput } from "@shared/schemas";

/**
 * Hook for creating a new user
 */
export const useCreateUser = () => {
  // Get the trpc context for revalidating queries
  // @ts-ignore - Type checking for trpc.useContext
  const utils = trpc.useContext();

  // Create user mutation
  // @ts-ignore - Type checking for trpc.user property
  const {
    // mutate, // Commented out as it's not used
    mutateAsync,
    isLoading,
    isError,
    error,
    isSuccess,
    reset,
  } = trpc.user.createUser.useMutation({
    onSuccess: () => {
      // Invalidate the users list query to refresh data
      // @ts-ignore - Type checking for utils.user property
      utils.user.getUsers.invalidate();
    },
  });

  // Function to create a user with better error handling
  const createUser = useCallback(
    async (userData: CreateUserInput) => {
      try {
        const result = await mutateAsync(userData);
        return { success: true, data: result };
      } catch (err: any) {
        return {
          success: false,
          error: err?.message || "Failed to create user",
        };
      }
    },
    [mutateAsync],
  );

  return {
    createUser,
    isLoading,
    isError,
    error,
    isSuccess,
    reset,
  };
};
